import { useIntl } from "react-intl";
import { Control } from "react-hook-form";

import { PostMeetingFormWithSummary } from "../form";
import { FIELD_LABELS } from "../messages";

import TextField from "./TextField";

export interface SkillsCommentsFieldProps {
  control: Control<PostMeetingFormWithSummary>;
}

export default function SkillsCommentsField({
  control,
}: SkillsCommentsFieldProps) {
  const { $t } = useIntl();
  return (
    <TextField
      name="skillsComments"
      label={$t(FIELD_LABELS.skillsComments)}
      control={control}
    />
  );
}
